import script from "./FarmBoundaryMap.vue?vue&type=script&setup=true&lang=js"
export * from "./FarmBoundaryMap.vue?vue&type=script&setup=true&lang=js"

import "./FarmBoundaryMap.vue?vue&type=style&index=0&id=74a648c0&scoped=true&lang=css"
import "./FarmBoundaryMap.vue?vue&type=style&index=1&id=74a648c0&lang=css"
script.__scopeId = "data-v-74a648c0"

export default script